import React from 'react';
export const Footer = () => <footer className="portfolio-footer"><div className="portfolio-container"><p>&copy; {new Date().getFullYear()} Anurag Kumar</p><span>Full-stack engineering & applied AI</span></div></footer>;
